import { message } from 'antd';
import getBaseUrl from '../utils/getBaseUrl';
import { useAuthContext } from '../context/auth-context';

export default function useHttpClient() {
  const { token, logout } = useAuthContext();

  const caseStatus = (status, responseData) => {
    if (status === 400) {
      const messages = Object.values(responseData);
      messages.forEach(error => {
        if (error[0] === 'Ο λογαριασμός έχει διαγραφεί') {
          logout();
        }
        message.error(`${error}`);
      });
      const error = new Error(messages.flat().join(', '));
      error.status = status;
      error.data = responseData;
      throw error;
    }
    if (status > 401) {
      message.error('Κάτι πήγε στραβά. Δοκιμάστε ξανά.');
      const error = new Error(`HTTP ${status}`);
      error.status = status;
      error.data = responseData;
      throw error;
    }

    if (status === 204) {
      return null;
    }
    return responseData;
  };

  const sendRequest = async ({ endpoint, method, bodyData }) => {
    const fetchBody = bodyData ? JSON.stringify(bodyData) : null;
    try {
      const response = await fetch(getBaseUrl() + endpoint, {
        method,
        body: fetchBody,
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json',
          Accept: 'application/json'
        }
      });

      const { status } = response;

      if (status === 401) {
        logout();
      }
      if (status === 204) {
        return null;
      }

      const responseData = await response.json();
      return caseStatus(status, responseData);
    } catch (error) {
      if (error.message) {
        throw error;
      }
      message.error('Πρόβλημα στο δίκτυο');
      message.error('Κάτι πήγε στραβά');
      return null;
    }
  };
  return { sendRequest };
}
